/*
 * Lumeer: Modern Data Definition and Processing Platform
 *
 * Copyright (C) since 2017 Lumeer.io, s.r.o. and/or its affiliates.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export const APP_NAME_SELECTOR = 'lmr-app';

export const DEFAULT_USER = 'aturing@lumeer.io';

export const DEFAULT_ICON = 'fas fa-question-circle';

export const DEFAULT_COLOR = '#cccccc';

export const COLOR_GRAY100 = '#f8f9fa';
export const COLOR_GRAY200 = '#ecf0f1';
export const COLOR_GRAY300 = '#dee2e6';
export const COLOR_GRAY400 = '#ced4da';
export const COLOR_GRAY500 = '#b4bcc2';
export const COLOR_GRAY600 = '#95a5a6';
export const COLOR_GRAY700 = '#7b8a8b';
export const COLOR_GRAY800 = '#343a40';
export const COLOR_GRAY900 = '#212529';

export const COLOR_BLUE = '#253746';
export const COLOR_INDIGO = '#6610f2';
export const COLOR_PURPLE = '#6f42c1';
export const COLOR_PINK = '#e83e8c';
export const COLOR_RED = '#e74c3c';
export const COLOR_ORANGE = '#fd7e14';
export const COLOR_LIGHT_ORANGE = '#fdd835';
export const COLOR_AMBER = '#ffd54f';
export const COLOR_YELLOW = '#f39c12';
export const COLOR_GREEN = '#00b388';
export const COLOR_TEAL = '#20c997';
export const COLOR_CYAN = '#3498db';

export const COLOR_PRIMARY = COLOR_BLUE;
export const COLOR_SECONDARY = COLOR_GRAY600;
export const COLOR_SUCCESS = COLOR_GREEN;
export const COLOR_INFO = COLOR_CYAN;
export const COLOR_WARNING = COLOR_YELLOW;
export const COLOR_DANGER = COLOR_RED;
export const COLOR_LIGHT = COLOR_GRAY200;
export const COLOR_DARK = COLOR_GRAY700;

export const COLOR_QUERY_FULLTEXT = '#faeabb';
export const COLOR_QUERY_DEFAULT = '#ffffff';
export const COLOR_LINK_DEFAULT = '#ffffff';

export const DRAG_DELAY = window.matchMedia('(max-width: 767.98px)').matches ? 150 : 0;

export const USER_AVATAR_SIZE = 22;

export const TABLE_ROW_MIN_HEIGHT = 34;

export const LUMEER_REFERRAL = 'lumeer_referral';

export const DEFAULT_FILE_SIZE_MB = 10;

export const POPUP_DELAY = 700;
